import { render, staticRenderFns } from "./shortcut.vue?vue&type=template&id=65280305&scoped=true"
import script from "./shortcut.vue?vue&type=script&lang=js"
export * from "./shortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65280305",
  null
  
)

export default component.exports